import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ErrorPage from '@rsos/components/capstone/ErrorPage';
import AppLoading from '@rsos/components/capstone/Layout/AppLoading';
import { gspx } from '@rsos/gainsight';
import Main from './Main';
import { initialize } from './appSlice';
import { persistor } from './store';

const useInitialize = dispatch => {
  useEffect(() => {
    (async () => {
      const action = await dispatch(initialize());
      if (action && action.error) {
        throw new Error(action.error);
      }

      gspx.identify();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

const App = () => {
  const dispatch = useDispatch();
  const { initialized, initializing, initError } = useSelector(
    state => state.communication,
  );
  useInitialize(dispatch);

  return useMemo(() => {
    if (initError) {
      return <ErrorPage persistor={persistor} />;
    }

    if (initializing) {
      return <AppLoading />;
    }

    if (initialized) {
      return <Main persistor={persistor} />;
    }

    return <ErrorPage persistor={persistor} />;
  }, [initialized, initializing, initError]);
};

export default App;
